import _ from "lodash";
import * as types from "../types";
import { changeCaseOn, createFormData } from "../utils";

export const getSessionPresentations = () => ({
  type: types.GET_SESSION_PRESENTATIONS,
  request: {
    url: "/session_presentations",
    method: "GET"
  }
});

export const getSessionPresentation = ({ id }) => ({
  type: types.GET_SESSION_PRESENTATION,
  request: {
    url: `/session_presentations/${id}`,
    method: "GET"
  }
});

export const updateSessionPresentation = ({ id, sessionPresentation }) => {
  const formData = new FormData();
  const sessionPresentationData = changeCaseOn("snakeCase", sessionPresentation, ["file"]);
  createFormData(formData, "session_presentation", sessionPresentationData);

  if (sessionPresentation.file)
    formData.append(`session_presentation[file]`, sessionPresentation.file);
  return {
    type: types.UPDATE_SESSION_PRESENTATION,
    request: {
      url: `/session_presentations/${id}`,
      method: "PATCH",
      headers: {
        "Content-Type": "multipart/form-data"
      },
      data: formData
    },
    meta: {
      mutations: {
        [types.GET_SESSION_PRESENTATIONS]: (prevData, newData) => {
          const data = _.sortBy(
            [
              ..._.filter(
                prevData.session_presentations,
                x => x.id !== newData.session_presentation.id
              ),
              newData.session_presentation
            ],
            ["title"]
          );
          return {
            session_presentations: data
          };
        }
      }
    }
  };
};
